export const HOME_ENDPOINTS = {
  ALL_USER_PRODUCTS: '/users/me/products/all?fusions=true',
};

export const HOME_QUERY_KEYS = {
  ALL_USER_PRODUCTS: 'HOME_ALL_USER_PRODUCTS',
};
